import { Text, View } from "@react-pdf/renderer";
import { styles } from "./styles";
import { GraphViewer } from "./utils/graph";

export const SlaPage = ({ graphcs, sharedOptions, relatorio, show }) => {
	return (
		<View style={styles.firsPageContainer}>
			<Text style={styles.title}>{"Métricas"}</Text>
			{!!show?.availability && (
				<View style={styles.metricsInLine}>
					<Text
						style={[
							styles.text,
							{
								textIndent: "20px",
								paddingRight: "170px",
							},
						]}
					>
						O gráfico de pizza representa a porcentagem de tempo em que os
						equipamentos monitorados estiveram disponíveis ou indisponíveis
						durante o período analisado, com base nas respostas ICMP ping.
					</Text>

					<GraphViewer
						graphcs={graphcs?.graphPing}
						sharedOptions={sharedOptions}
						description={`Disponibilidade`}
						font={`Fonte: Dados coletados pelo ${relatorio?.source}`}
						options={{
							header: {},
							container: { width: "180px", marginTop: "-5px" },
							footer: {
								marginTop: "-5px",
							},
						}}
					/>
				</View>
			)}
			{!!show?.packetLoss && (
				<View style={styles.metricsInColumn}>
					<Text
						style={[
							styles.text,
							{
								textIndent: "20px",
							},
						]}
					>
						O gráfico a seguir exibe a variação na taxa de perda de pacotes ao
						longo do tempo, com base nos dados coletados dos equipamentos
						monitorados via ICMP.
					</Text>
					<GraphViewer
						graphcs={graphcs?.graphPacketLoss}
						sharedOptions={sharedOptions}
						description={`Perda de Pacotes`}
						font={`Fonte: Dados coletados pelo ${relatorio?.source}`}
						options={{
							header: {},
							container: {},
							footer: {},
						}}
					/>
				</View>
			)}
			{!!show?.latency && (
				<View style={styles.metricsInColumn}>
					<Text
						style={[
							styles.text,
							{
								textIndent: "20px",
							},
						]}
					>
						O gráfico a seguir mostra a variação da latência (tempo de resposta)
						nas comunicações ICMP com os equipamentos monitorados ao longo do
						tempo.
					</Text>
					<GraphViewer
						graphcs={graphcs?.graphLatency}
						sharedOptions={sharedOptions}
						description={`Latência`}
						font={`Fonte: Dados coletados pelo ${relatorio?.source}`}
						options={{
							header: {},
							container: {},
							footer: {},
						}}
					/>
				</View>
			)}
			{!!show?.table && (
				<View style={styles.tableDescription}>
					<View style={styles.tableDescriptionHeader}>
						<Text>Métrica</Text>
						<Text>Resultados no período</Text>
						<Text>Valor</Text>
					</View>

					{relatorio?.metricsTable?.values?.availability && (
						<View style={styles.tableDescriptionRow}>
							<View style={styles.metricsTable.leftColumn}>
								<Text>Disponibilidade de Coleta de Ping</Text>
							</View>
							<View style={styles.metricsTable.middleColumn}>
								<Text>{`${relatorio?.metricsTable?.values?.availability?.toFixed(
									2,
								)} %`}</Text>
							</View>
							<View style={styles.metricsTable.rightColumn}>
								<Text>{`${
									relatorio?.metricsTable?.values?.availability >=
									relatorio?.metricsTable?.ref?.availability
										? ">"
										: "<"
								} ${relatorio?.metricsTable?.ref?.availability} %`}</Text>
							</View>
						</View>
					)}

					{relatorio?.metricsTable?.values?.latency && (
						<View style={styles.tableDescriptionRow}>
							<View style={styles.metricsTable.leftColumn}>
								<Text>Latência Média (ms)</Text>
							</View>
							<View style={styles.metricsTable.middleColumn}>
								<Text>{`${relatorio?.metricsTable?.values?.latency?.toFixed(
									2,
								)} ms`}</Text>
							</View>
							<View style={styles.metricsTable.rightColumn}>
								<Text>{`${
									relatorio?.metricsTable?.values?.latency >
									relatorio?.metricsTable?.ref?.latency
										? ">"
										: "<"
								} ${relatorio?.metricsTable?.ref?.latency} ms`}</Text>
							</View>
						</View>
					)}

					{relatorio?.metricsTable?.values?.packetLoss && (
						<View
							style={{ ...styles.tableDescriptionRow, borderBottom: "none" }}
						>
							<View style={styles.metricsTable.leftColumn}>
								<Text>Perda de Pacotes (%)</Text>
							</View>
							<View style={styles.metricsTable.middleColumn}>
								<Text>{`${relatorio?.metricsTable?.values?.packetLoss?.toFixed(
									2,
								)} %`}</Text>
							</View>
							<View style={styles.metricsTable.rightColumn}>
								<Text>{`${
									relatorio?.metricsTable?.values?.packetLoss >
									relatorio?.metricsTable?.ref?.packetLoss
										? ">"
										: "<"
								} ${relatorio?.metricsTable?.ref?.packetLoss} %`}</Text>
							</View>
						</View>
					)}
				</View>
			)}
			{relatorio?.observacoes && (
				<View
					style={{
						...styles.metricsInColumn,
						marginTop: 10,
						padding: 10,
						backgroundColor: "#f5f5f5",
						borderRadius: 4,
						width: "100%",
					}}
					wrap
				>
					<Text
						style={{
							fontSize: 12,
							fontFamily: "Times-Bold",
							marginBottom: 5,
							color: "#000000",
						}}
					>
						Observações:
					</Text>

					<Text
						style={{
							fontSize: 12,
							textAlign: "justify",
							fontFamily: "Times-Roman",
							lineHeight: 1.5,
							width: "100%",
						}}
					>
						{relatorio.observacoes}
					</Text>
				</View>
			)}
		</View>
	);
};
